import { WITHDRAWS, WITHDRAWS_PAGINATE, WITHDRAW_UPDATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import formatedFilters from '@helpers/formatAxiosGetFilters'

const state = {
  withdraws: [],
  paginate: {}
}

const getters = {
  [WITHDRAWS]: 'withdraws',
  [WITHDRAWS_PAGINATE]: 'paginate'
}

const mutations = {
  [WITHDRAWS]: 'withdraws',
  [WITHDRAWS_PAGINATE]: 'paginate'
}

const actions = {
  [WITHDRAWS]: async ({ commit, dispatch }, payload = {}) => {
    const filters = formatedFilters(payload)
    try {
      const response = await axios.get(`/withdraws?${filters}`)
      if (response && response.data && response.data.data) {
        const { data: withdraws, ...paginate } = response?.data || {}
        commit(WITHDRAWS, withdraws)
        commit(WITHDRAWS_PAGINATE, paginate.meta)
        return response
      } else {
        dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível obter os saques'))
      }
    } catch (error) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível obter os saques'))
    }
  },
  [WITHDRAW_UPDATE]: async ({ dispatch }, payload) => {
    try {
      const response = await axios.patch('/withdraws', {
        status: 1,
        withdraws: payload
      })
      if (response && response.data && response.data.success) {
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message: 'Status atualizado com sucesso!'
        })
        return response
      } else {
        dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível atualizar o status'))
      }
    } catch (error) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível atualizar o status'))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/withdraws.js